// ------------------------------------token的本地存储------------------------------------

// 用户 Token 的本地缓存键名，自己定义
const TOKEN_KEY = 'LSQTZJNGSZTSG_HT_USER_INFO'
const PLATE_ID_KEY = 'LSQTZJNGSZTSG_HT_PLATE_ID'

/**
 * 从本地缓存中获取 用户 信息
 */
export const getTokenInfo = (): any => {
  const tokenText = localStorage.getItem(TOKEN_KEY)
  if (!tokenText) return {}
  try {
    return JSON.parse(tokenText)
  } catch {
    return {}
  }
}

/**
 * 将 用户 信息存入缓存
 * @param {Object} tokenInfo 从后端获取到的 Token 信息
 */
export const setTokenInfo = (tokenInfo: any): void => {
  localStorage.setItem(TOKEN_KEY, JSON.stringify(tokenInfo))
}

/**
 * 删除本地缓存中的 用户 信息
 */
export const removeTokenInfo = (): void => {
  localStorage.removeItem(TOKEN_KEY)
}

/**
 * 判断本地缓存中是否存在 Token 信息
 */
export const hasToken = (): boolean => {
  return Boolean(getTokenInfo().token)
}

/**
 * 获取本地缓存中是否存在 Token 信息
 */
export const getTokenFu = (): string => {
  return getTokenInfo().token
}

/**
 * 保存当前板块 id
 */
export const setPlateId = (plateId: number): void => {
  localStorage.setItem(PLATE_ID_KEY, String(plateId || 0))
}

/**
 * 获取当前板块 id
 */
export const getPlateId = (): number => {
  const plateIdText = localStorage.getItem(PLATE_ID_KEY)
  if (!plateIdText) return 0
  const plateId = Number(plateIdText)
  return Number.isFinite(plateId) ? plateId : 0
}

/**
 * 删除当前板块 id
 */
export const removePlateId = (): void => {
  localStorage.removeItem(PLATE_ID_KEY)
}

// 解析json
export const safeParseJson = (jsonText?: string) => {
  if (!jsonText) return {}
  try {
    const parsed = JSON.parse(jsonText)
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch {
    return {}
  }
}
